(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-article"]) return;
  try {
    
  // 2026-09-13 (audit ANIM A10): kuldes kozben a gomb letiltva es 'Kuldes...' allapotban.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.closest || !f.closest('.pm-cikk-hirlevel')) return;
    var b = f.querySelector('button[type="submit"]');
    if (!b || b.disabled) return;
    b.disabled = true;
    b.classList.add('pm-nl-gomb--kuld');
    b.dataset.pmEredeti = b.textContent;
    b.textContent = 'Küldés…';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-faq-newsletter"] && !Shopify.designMode) return;
  try {
    
  // 2026-09-13 (audit ANIM A10): kuldes kozben a gomb letiltva es 'Kuldes...' allapotban.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.closest || !f.closest('.pm-fn-newsletter-form')) return;
    var b = f.querySelector('button[type="submit"]');
    if (!b || b.disabled) return;
    b.disabled = true;
    b.classList.add('pm-nl-gomb--kuld');
    b.dataset.pmEredeti = b.textContent;
    b.textContent = 'Küldés…';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-sticky-cart-bar"]) return;
  try {
    
(function () {
  var bar = document.getElementById('pm-sticky-cart');
  if (!bar) return;

  // 2026-09-13 (audit MUK-03): csak mobilon aktív; a hidden levétele nélkül
  // a :not([hidden]) szabály miatt a sáv display:none maradt.
  var pmMobil = window.matchMedia('(max-width: 749px)');
  function pmStickyMobil() { bar.hidden = !pmMobil.matches; }
  pmStickyMobil();
  if (pmMobil.addEventListener) pmMobil.addEventListener('change', pmStickyMobil);

  // A formazas egy helyen el: assets/pm-money.js.
  function pmStickyFormatHuf(cents) {
    return window.pmMoney.formatHuf(cents);
  }

  function getSelectedVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var inp = form.querySelector('input[name="id"]');
      if (inp) return inp.value;
    }
    return bar.dataset.variantId;
  }

  // Keep price/image in sync when the shopper picks a different variant.
  document.addEventListener('variant:update', function (e) {
    if (!e.detail || !e.detail.resource) return;
    var productId = e.detail.data && e.detail.data.productId;
    if (productId && bar.dataset.productId && productId !== bar.dataset.productId) return;

    var variant = e.detail.resource;
    bar.dataset.variantId = variant.id;

    var priceEl = document.getElementById('pm-sticky-cart-price');
    if (priceEl && typeof variant.price === 'number') {
      // Kezi ezres tagolas. A toLocaleString('hu-HU') a negyjegyu
      // szamokat NEM tagolja (1600 -> "1600 Ft"), a bolt penzformatuma
      // viszont igen ("1.600 Ft") - igy a tapado savban mas ar allt,
      // mint a panelben, pont a kosarba kattintas elott.
      priceEl.textContent = pmStickyFormatHuf(variant.price);
    }

    var imageEl = document.getElementById('pm-sticky-cart-image');
    if (imageEl && variant.featured_media && variant.featured_media.preview_image) {
      imageEl.src = variant.featured_media.preview_image.src + '&width=100';
    }

    var stickyBtn = document.getElementById('pm-sticky-cart-btn');
    // 2026-10-10: a gombban ikon is van, ezért csak a felirat-span szövege változik.
    var stickyLabel = stickyBtn ? (stickyBtn.querySelector('.pm-sticky-cart__label') || stickyBtn) : null;
    if (stickyBtn && !stickyBtn.disabled) {
      stickyLabel.textContent = variant.available ? 'Kosárba' : 'Nem elérhető';
      stickyBtn.disabled = !variant.available;
    }
  });

  // IntersectionObserver on the main add-to-cart button
  var mainBtn = document.querySelector('[name="add"]');
  if (mainBtn && window.IntersectionObserver) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          bar.classList.add('pm-sticky-cart--visible');
        } else {
          bar.classList.remove('pm-sticky-cart--visible');
        }
      });
    }, { threshold: 0.2 });
    observer.observe(mainBtn);
  }

  var stickyBtn = document.getElementById('pm-sticky-cart-btn');
  if (!stickyBtn) return;
  var stickyLabel = stickyBtn.querySelector('.pm-sticky-cart__label') || stickyBtn;

  stickyBtn.addEventListener('click', function () {
    var variantId = getSelectedVariantId();
    if (!variantId) return;
    stickyBtn.disabled = true;
    stickyLabel.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        stickyLabel.textContent = 'Hozzáadva ✓';
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            // Trigger the theme's native cart-update flow so the single
            // native cart drawer refreshes its contents and auto-opens
            // (matches the shape of @theme/events CartAddEvent).
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'pm-sticky-cart-bar', data: {} }
            }));
          });
        setTimeout(function () {
          stickyBtn.disabled = false;
          stickyLabel.textContent = 'Kosárba';
        }, 2000);
      })
      .catch(function () {
        stickyBtn.disabled = false;
        stickyLabel.textContent = 'Kosárba';
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-wishlist-page"]) return;
  try {
    
  (function () {
    function formatFt(cents) {
      var ft = Math.round(cents / 100);
      return ft.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' Ft';
    }

    function renderCard(product) {
      var variant = product.variants && product.variants[0];
      var image = product.featured_image || (product.images && product.images[0]);
      var price = variant ? variant.price : product.price;

      var card = document.createElement('div');
      card.className = 'pm-wishlist-card';
      card.innerHTML =
        '<a href="' + product.url + '" class="pm-wishlist-card__img-wrap">' +
          (image ? '<img src="' + image + '&width=500" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="pm-wishlist-card__body">' +
          '<a href="' + product.url + '" class="pm-wishlist-card__title">' + product.title + '</a>' +
          '<p class="pm-wishlist-card__price">' + formatFt(price) + '</p>' +
        '</div>' +
        '<button type="button" class="pm-wishlist-card__remove" data-wishlist-toggle data-handle="' + product.handle + '" aria-label="Eltávolítás a kedvencekből">×</button>';
      return card;
    }

    function render() {
      var handles = window.pmWishlist ? window.pmWishlist.get() : [];
      var grid = document.getElementById('pm-wishlist-grid');
      var empty = document.getElementById('pm-wishlist-empty');
      if (!grid || !empty) return;

      if (handles.length === 0) {
        grid.innerHTML = '';
        empty.hidden = false;
        return;
      }
      empty.hidden = true;

      Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (res) { return res.ok ? res.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        grid.innerHTML = '';
        products.filter(Boolean).forEach(function (product) {
          grid.appendChild(renderCard(product));
        });
        if (grid.children.length === 0) {
          empty.hidden = false;
        }
      });
    }

    document.addEventListener('pm:wishlist-change', render);
    document.addEventListener('DOMContentLoaded', render);
    if (document.readyState !== 'loading') render();
  })();

  } catch(e) { console.error(e); }
})();
})();
